import get from 'lodash.get';

const getPartnerLogoWidth = (rootState) =>
  get(rootState, 'partner.properties.wsBranding.companyLogoWidth');

export default getPartnerLogoWidth;
